import { MsgEventBus } from "@client/page/MsgHistory";
import { css, cx, injectGlobal } from "@emotion/css";
import { Button, notification } from "antd";
import React from "react";
import { Color, ColorDerived, Style } from "../style";

notification.config({
  maxCount: 1,
});

type TMsgOption = Partial<{
  title: string;
  okText: string;
}>;

injectGlobal`
  .ant-notification-notice-description {
    font-size: 2rem;
  }
  .ant-notification-notice-content{
    width: 100%;
  }
`;

export async function showMsg(msg: React.ReactNode, options?: TMsgOption): Promise<void> {
  MsgEventBus.emit("newMsg", msg);
  let autoCloseDelay = 3;
  if (typeof msg === "string") {
    autoCloseDelay = Math.min(msg.length / 12, 5);
  }
  const key: string = JSON.stringify(msg);
  return new Promise<void>((resolve) => {
    const autoClose = !options?.okText;
    if (autoClose) {
      setTimeout(() => resolve(), autoCloseDelay * 1e3 + 500);
    }
    const title = options?.title;
    notification.open({
      key,
      message: title && (
        <div
          className={css`
            font-size: 2.5rem;
            padding: 1.5rem 0;
            color: ${Color.light};
          `}
        >
          {title}
        </div>
      ),
      closeIcon: <></>,
      placement: "bottom",
      description: <div>{msg}</div>,
      className: css`
        overflow: visible;
        display: flex;
        justify-content: center;
        width: ${key.length < 20 ? "40vw" : "60vw"};
        max-width: 100rem;
        color: ${Color.light};
        background: ${ColorDerived.darkMain};
        padding: 1.5rem 3rem;
        position: relative;
        //left: calc(-50vw + 50%);
        border-radius: 1rem;
        box-shadow: ${Style.shadowNormal};
      `,
      duration: autoClose ? autoCloseDelay : 0,
      btn: autoClose ? null : (
        <Button
          className={cx(
            Style.btnPrimarySm,
            css`
              background: ${Color.main}!important;
            `
          )}
          onClick={() => {
            notification.close(key);
            setTimeout(() => resolve(), 300);
          }}
        >
          {options?.okText}
        </Button>
      ),
    });
  });
}
